import {useContext} from 'react';

import {Doughnut} from 'react-chartjs-2';
import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import {PrevalentDepartment} from '../types/RecruitingDashboardTypes';

import {LanguageContext} from '../../../../../contexts/LanguageContext/LanguageContext';
import {greenColors} from '../../../../../layouts/theme/designSystem';

interface Props {
  data: any;
  rejectionPercentage: number;
  deparmentData: PrevalentDepartment;
}

export const DoughnutRates = ({data, rejectionPercentage, deparmentData}: Props) => {
  const {t} = useTranslation();
  const currentLanguage = useContext(LanguageContext);
  const department = deparmentData.methodDepartmentCategory.name[currentLanguage];
  const percentage = deparmentData.methodDepartmentCategory.percentage;

  return (
    <Grid
      item
      container
      sx={{
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box width={56} height={56}>
        <Doughnut
          data-testid='rejection-percentages-doughnut'
          data={data}
          options={{
            plugins: {
              tooltip: {enabled: false},
              legend: {display: false},
            },
            elements: {
              arc: {
                hoverBorderColor: 'rgba(0,0,0,0)',
                hoverBackgroundColor: (context: any) => {
                  if (Array.isArray(context.dataset.backgroundColor)) {
                    return (context.dataset.backgroundColor as string[])[context.dataIndex];
                  }
                  return context.dataset.backgroundColor;
                },
              },
            },
          }}
        />
      </Box>
      <Grid item xs marginLeft={4}>
        <Typography
          variant='h3'
          sx={{
            color: greenColors[100],
          }}
        >
          {rejectionPercentage}%
        </Typography>
        <Typography variant='body1' color={greenColors[2]}>
          {t('companyRecruitingDashboard.rejections.fromCompany', {
            department,
            percentage,
          })}
        </Typography>
      </Grid>
    </Grid>
  );
};
